<script>
  import { createEventDispatcher, onDestroy, onMount } from 'svelte';

  import Modal from '@components/Modal.svelte';
  import BenableLogo from '@components/BenableLogo.svelte';
  import { goto } from '$app/navigation';

  import { getGlobalStore } from '@stores/global';
  let recRequestGroupStore = getGlobalStore('recRequestGroupStore');

  const dispatch = createEventDispatcher();

  export let mobile = false;
  export let show = false;

  let recRequestGroup = recRequestGroupStore;
  let totalCompleted = 0;

  let unsub = recRequestGroupStore.subscribe((x) => {
    recRequestGroup = x;

    if (recRequestGroup && recRequestGroup.rec_requests) {
      totalCompleted = 0;
      recRequestGroup.rec_requests.forEach((x) => {
        if (x.completed) {
          totalCompleted += 1;
        }
      });
    }
  });

  const containerSize = {
    6: 'height: 607px; width: 583px;',
    5: 'height: 551px; width: 566px;',
    4: 'height: 570px; width: 626px;',
    3: 'height: 450px; width: 566px;',
    2: 'height: 607px; width: 626px;',
  };

  const finishedConfig = {
    1: {
      src: '/images/rec_request_group/arm.png',
      style: 'background-color: #2CAF87;',
    },
    2: {
      src: '/images/rec_request_group/party.png',
      style: 'background-color: #A893F9;',
    },
    3: {
      src: '/images/rec_request_group/clap.png',
      style: 'background-color: #68B7FF;',
    },
    4: {
      src: '/images/rec_request_group/face.png',
      style: 'background-color: #FF5567;',
    },
    5: {
      src: '/images/rec_request_group/party2.png',
      style: 'background-color: #A4DB07;',
    },
    6: {
      src: '/images/rec_request_group/star.png',
      style: 'background-color: #FFB768;',
    },
  };

  const positions = {
    6: [
      'top: 0px; left: calc(50% - 85px);',
      'top: 105px; right: 0px;',
      'bottom: 105px; right: 0px;',
      'bottom: 0px; left: calc(50% - 85px);',
      'bottom: 105px; left: 0px;',
      'top: 105px; left: 0px;',
    ],

    5: [
      'top: 0px; left: calc(50% - 85px);',
      'top: 160px; right: 0px;',
      'bottom: 0px; right: 85px;',
      'bottom: 0px; left: 85px;',
      'top: 160px; left: 0px;',
    ],

    4: [
      'top: 0px; left: calc(50% - 85px);',
      'top: calc(50% - 85px); right: 0px;',
      'bottom: 0px; left: calc(50% - 85px);',
      'top: calc(50% - 85px); left: 0px;',
    ],

    3: ['top: 0px; left: calc(50% - 85px);', 'bottom: 0px; right: 0px;', 'bottom: 0px; left: 0px;'],

    2: ['top: calc(50% - 85px); left: 0px;', 'top: calc(50% - 85px); right: 0px;'],
  };

  let goToRecRequest = function (rr) {
    goto(rr.token_url);
  };

  onMount(() => {
    let url = new URL(location.href);
    url.searchParams.set('quizzes', 1);
    window.history.pushState('', '', url);
  });

  onDestroy(() => {
    let url = new URL(location.href);
    url.searchParams.delete('quizzes');
    window.history.pushState('', '', url);

    unsub();
  });
</script>

<style style="text/scss" lang="scss">
  * :global(.modal__container) {
    background: linear-gradient(315.85deg, #eae4ff 7.02%, #ffffff 66.28%),
      linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
    width: 100% !important;
    max-width: unset !important;
    height: 100vh !important;
    margin: 0px !important;
    border-radius: 0px !important;
  }

  .bg-image {
    position: fixed;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    height: 100vh;
    width: 100%;
    object-fit: cover;
    z-index: -1;
  }

  .rrq-container {
    margin-top: -55px;

    .rrq-header {
      font-weight: bold;
      font-size: 18px;
      line-height: 22px;
      text-align: center;
      text-transform: uppercase;
      display: flex;
      align-items: center;
      justify-content: center;

      div:first-child {
        margin-right: 10px;
        margin-top: -2px;
      }
    }

    .rrq-description {
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      color: #7f7f7f;
      margin-top: 24px;
      max-width: 620px;
      margin-left: auto;
      margin-right: auto;
    }

    .rrq-header-description-container {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: calc(50% - 390px);
    }

    .rrq-circles-container {
      width: 566px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateY(calc(-50% + 50px)) translateX(-50%);
      margin-left: auto;
      margin-right: auto;

      .rrq-count-container {
        position: absolute;
        top: calc(50% - 43px);
        left: calc(50% - 75px);
        width: 150px;
        height: 87px;
        text-align: center;

        .rr-count {
          font-weight: bold;
          font-size: 52px;
          line-height: 64px;
          text-align: center;
          color: #a893f9;
        }

        .rr-count-text {
          font-size: 11px;
          line-height: 13px;
          text-align: center;
          text-transform: uppercase;
          margin-top: 10px;
          font-weight: bold;
          color: #1a1a1a;
        }
      }

      .rr-circle {
        background: #ffffff;
        box-shadow: 0px 22px 50px rgba(0, 0, 0, 0.08);
        border-radius: 999px;
        width: 170px;
        height: 170px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 30px;
        cursor: pointer;

        &:hover {
          box-shadow: 0px 8px 56px rgba(0, 0, 0, 0.16);
        }

        &.finished {
          .rr-circle-title {
            color: white;
            margin-top: 13px;
          }
        }

        .rr-emoji-success {
          margin-top: 5px;
          margin-bottom: -5px;
        }

        .rr-emoji {
          width: 24px;
          height: 24px;
        }

        .rr-circle-title {
          font-weight: 700;
          font-size: 14px;
          line-height: 20px;
          text-align: center;
          height: 40px;
          margin-top: 16px;
          overflow: hidden;
          display: flex;
          align-items: center;
        }

        .rr-duration {
          display: flex;
          align-items: center;
          margin-top: 10px;

          div {
            margin-left: 8px;
            font-size: 14px;
            line-height: 18px;
            color: #7f7f7f;
          }
        }
      }
    }
  }

  .mobile {
    .rrq-container {
      .rrq-header {
        margin-top: 88px;
      }

      .rrq-header-description-container {
        position: unset;
        left: unset;
        transform: unset;
        top: unset;
      }

      .rrq-circles-container {
        height: unset !important;
        width: unset !important;
        position: unset;
        transform: unset;
        margin-top: 30px;

        .rrq-count-container {
          position: unset;
          width: unset;
          height: unset;
          margin-bottom: 30px;

          .rr-count {
            font-size: 40px;
            line-height: 48px;
          }
        }

        .rr-circles {
          display: flex;
          flex-wrap: wrap;
          width: 312px;
          margin-left: auto;
          margin-right: auto;

          .rr-circle {
            position: unset !important;
            height: 136px;
            width: 136px;
            padding: 20px;
            margin-left: 10px;
            margin-right: 10px;
            margin-bottom: 20px;

            .rr-emoji-success {
              width: 40px;
              height: 40px;
              margin-top: 0px;
              margin-bottom: 0px;
            }

            .rr-circle-title {
              line-height: 17px;
              margin-top: 8px;
            }
          }
        }
      }
    }
  }

  * :global(.modal__close_ios) {
    margin-top: -8px !important;
  }

  * :global(.modal__close) {
    margin-top: -15px;

    &:before {
      color: #a893f9;
      font-size: 26px;
    }
  }
</style>

{#if recRequestGroup && recRequestGroup.id}
  <div class="svelte-modal">
    <Modal
      style={mobile
        ? 'position: absolute !important; top: 0px !important; left: 0px !important; right: 0px !important; bottom: 0px !important; margin: 0px !important;'
        : ''}
      mobile={mobile}
      on:close={() => {
        show = false;
        dispatch('close');
      }}
      bind:show={show}
      showCloseButton={true}
      fadeInDuration={200}>
      <div slot="content" class:mobile={mobile}>
        <div style="position: fixed; {mobile ? 'top: 20px; left: 28px' : 'top: 30px; left: 40px; z-index: 2;'}">
          <BenableLogo />
        </div>

        {#if !mobile && totalCompleted === recRequestGroup.rec_requests.length}
          <img
            src="/images/rec_request/left-congrats.png"
            style="position: absolute; left: 0px; top: 50%; transform: translateY(-50%);" />

          <img
            src="/images/rec_request/right-congrats.png"
            style="position: absolute; right: 0px; top: 50%; transform: translateY(-50%);" />
        {/if}

        <img src="/images/rec_request_group/bg.png" class="bg-image" />

        <div class="rrq-container">
          <div class="rrq-header-description-container">
            <div class="rrq-header">
              <div>
                <img
                  src="/images/rec_request_group/fire.png"
                  srcset="/images/rec_request_group/fire.png 1x, /images/rec_request_group/fire@2x.png 2x" />
              </div>
              <div>JUMPSTART YOUR LISTS</div>
            </div>
            <div class="rrq-description">
              Take a quiz to create your first lists and keep track of your recommendations.
            </div>
          </div>

          <div class="rrq-circles-container" style={containerSize[recRequestGroup.rec_requests.length]}>
            <div
              class="rrq-count-container"
              style={recRequestGroup.rec_requests.length == 3 ? 'top: calc(50% - 18px);' : ''}>
              <div class="rr-count">
                {totalCompleted} of {recRequestGroup.rec_requests.length}
              </div>
              <div class="rr-count-text">Quizzes completed</div>
            </div>

            <div class="rr-circles">
              {#each recRequestGroup.rec_requests as rr, idx}
                <div
                  on:click={goToRecRequest(rr)}
                  class="rr-circle"
                  class:finished={rr.completed}
                  style="position: absolute; {positions[recRequestGroup.rec_requests.length][idx]} {rr.completed
                    ? finishedConfig[idx + 1].style
                    : ''}">
                  {#if rr.completed}
                    <img class="rr-emoji-success" src={finishedConfig[idx + 1].src} />
                  {:else}
                    <img class="rr-emoji" src={rr.emoji.outside_src} alt="{rr.emoji.name} emoji" />
                  {/if}

                  <div class="rr-circle-title">{rr.title}</div>

                  {#if !rr.completed}
                    <div class="rr-duration">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16
                  8C16 3.6 12.4 0 8 0ZM12 9H7V4H9V7H12V9Z"
                          fill="#D5CFEA" />
                      </svg>

                      <div>
                        {rr.duration}
                        {rr.duration == 1 ? 'min' : 'mins'}
                      </div>
                    </div>
                  {/if}
                </div>
              {/each}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
{/if}
